export default __webpack_public_path__ + "static/media/Full-Stop to Life.fc9ad667.png";